import { GroupedHeaderListItem } from './GroupedHeaderList.types';

export function areAllHeaderListGroupsEmpty<T>(
  groups: GroupedHeaderListItem<T>[]
): boolean {
  return groups.every((group) => group.items.length === 0);
}
